import * as React from "react";
const IconTree = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M46.9 25.8c0-11.6-6-24-14.9-24s-14.9 12.4-14.9 24c0 11.3 5.4 20.3 12.7 21.9V60c0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3V47.7c7.1-1.6 12.5-10.6 12.5-21.9M34.2 43v-5.9c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3V43c-4.6-1.8-8.2-8.9-8.2-17.2 0-10 5.1-19.5 10.4-19.5s10.4 9.5 10.4 19.5c.2 8.2-3.4 15.4-8 17.2" />
  </svg>
);
export default IconTree;
